export const CONSULTATION_DETAILS_QUERY_KEY = 'CONSULTATION_DETAILS_QUERY_KEY';
export const FUTURE_CONSULTATIONS_QUERY_KEY = 'FUTURE_CONSULTATIONS_QUERY_KEY';

export const CONSULTATIONS_QUERY_KEY = 'CONSULTATIONS_QUERY_KEY';
export const VIDEO_CONSULTATIONS_REFRESH_INTERVAL = 5000;

export const TEXT_CONSULTATIONS_QUERY_KEY = 'TEXT_CONSULTATIONS_QUERY_KEY';
export const TEXT_CONSULTATIONS_REFRESH_INTERVAL = 20000;

export const CONSULTATION_MESSAGES_QUERY_KEY =
    'CONSULTATION_MESSAGES_QUERY_KEY';

export const MESSAGE_CONSULTATION_TYPES_QUERY_KEY =
    'MESSAGE_CONSULTATION_TYPES_QUERY_KEY';

export const VIDEO_CONSULTATION_TYPES_QUERY_KEY =
    'VIDEO_CONSULTATION_TYPES_QUERY_KEY';

export const PROFILE_TODAY_CONSULTATIONS_QUERY_KEY =
    'PROFILE_TODAY_CONSULTATIONS_QUERY_KEY';

export const CONSULTATION_DETAILS_PAST_CONSULTATIONS_QUERY_KEY =
    'CONSULTATION_DETAILS_PAST_CONSULTATIONS_QUERY_KEY';

export const PROFILE_CONSULTATION_DETAILS_QUERY_KEY =
    'PROFILE_CONSULTATION_DETAILS_QUERY_KEY';

export const PROFILE_PATIENT_RECORD_QUERY_KEY =
    'PROFILE_PATIENT_RECORD_QUERY_KEY';

export const consultationDetailsKeys = [
    CONSULTATION_DETAILS_PAST_CONSULTATIONS_QUERY_KEY,
    PROFILE_CONSULTATION_DETAILS_QUERY_KEY,
    CONSULTATION_DETAILS_QUERY_KEY,
];
